import { useQuery } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';

export const useAccountsWithPartnerDomains = (partnerId: string | null) => {
  const query = useQuery({
    queryKey: queryKeys.accounts.withPartnerDomains(partnerId!),
    queryFn: () => accountsService.getAccountsWithPartnerDomains(partnerId!),
    enabled: !!partnerId,
  });

  return {
    accounts: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useAccountsWithPartnerDomains;
